import React from 'react';
import './companyheader.css'
import {useDispatch, useSelector} from 'react-redux';
import { setUserLogout} from "./../userSlice"
import { useNavigate } from "react-router-dom";

function CompanyHeader() {

  let navigate = useNavigate();
  let dispatch = useDispatch();



  const logout = (e)=>{
    e.preventDefault();
    dispatch(setUserLogout());
    navigate('/');
  }


  return <div className="companyheader">
  <div className="companyheader-logo companyheader-btn">
    <div className='logo perfect-center' onClick={() => navigate('/')}>
        <img src="./images/jom.png"/> 
    </div>
  </div>
  <div className="companyheader-title companyheader-btn"><span className='perfect-center'>Job-O-Mania</span></div>
  <div className="companyheader-logout companyheader-btn" onClick={logout}><span className='perfect-center'>Logout <i class="fa fa-sign-out" aria-hidden="true"></i></span></div>
  <div className="companyheader-about companyheader-btn" onClick={() => navigate('/about')}><span className='perfect-center'>About <i class="fas fa-question-circle"></i></span></div>
</div>; ;
}

export default CompanyHeader;
